import { createAction } from 'redux-act';

export const initializeAuthWorker = createAction('Store access token', (accessToken) => ({ accessToken }));
export const saveUserName = createAction('Save User Name', (name) => ({ name }));
export const saveUserPhoto = createAction('Save User Photo', (photo) => ({ photo }));
